<template>
    <div style="margin-bottom: -5px;" class="row  go-form-row" v-show="inputItem.display == null ? true : inputItem.display">
        <go-label :labelWidth="labelWidth" :labelAlign="labelAlign" :item="inputItem"></go-label>
        <Date-picker
            :class="'go-content ' + getInputWid()"
            :value="value"
            type="month"
            :placeholder="PLACEHOLDERTEXT"
            @on-change="handleChange"
        ></Date-picker>
    </div>
</template>

<script>
    import formMixin from "../../mixins/formMixins";
    import GoLabel from "./commponents/go-label";

    export default {
        name: "go-calendar-month",
        mixins: [formMixin],
        data: function () {
            return {
                PLACEHOLDERTEXT: "选择年月"
            };
        },
        props: {

        },
        computed: {

        },
        methods: {
            handleChange(date) {
                this.$emit("input", date);
            }
        },
        mounted() {

        },
        components: {
            GoLabel
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-calendar-month.vue